import(/* webpackMode: "eager" */ "/app/apps/frontend/app/(dashboard)/image-generation/page.tsx");
